export default __webpack_public_path__ + "static/media/VideoDesactive.c28519ea.svg";